<template>
  <div class="mt-4">
    <div class="table-full-width table-responsive">
      <table v-if="timetable" class="table-rating">
        <thead>
          <tr>
            <th class="col-full"></th>
            <th valign="bottom" v-for="(table, k) in timetable" :key="k">
              <selector
                v-if="!holidays[table.date]"
                v-model="table.lessonplan"
                @input="setLessonplan(table, k)"
                :disableLabel="true"
                :prefix="`lessonplan_${table.id}`"
                :modal="`lessonplan`"
                :params="{
                  locale: group.locale,
                  discipline_id: discipline.id,
                  course_id: group.course.id,
                }"
                :selectKey="`title`"
              />
              <div v-else-if="holidays[table.date]">
                <h5>{{ holidays[table.date]["title"] }}</h5>
                <p>{{ holidays[table.date]["description"] }}</p>
              </div>
              <h5>{{ table.date | dateFormat }}</h5>
            </th>
            <th valign="bottom">
              <h5>Средний балл</h5>
            </th>
            <th valign="bottom">
              <h5>Итог</h5>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="client in clients" :key="client.id" >
            <td class="col-full">
              {{ client.id }} / {{ client.full_name | maxChar(30) }}
            </td>

            <td 
              :title="client.full_name"
              v-for="table in timetable"
              :key="table.id"
            >
         
                <ul :style="{background:red}" v-if="table.lessonplan" class="journal-control">
                  <li>
                    <attendance
                      v-model="client.timetable"
                      :client="client"
                      :table="table"
                    />
                  </li>
                  <li>
                    <ratings
                      :getJournal="getJournal"
                      v-model="client.ratings"
                      :client="client"
                      :table="table"
                    />
                  </li></ul
              >
            </td>
            <td :title="client.full_name">{{ ratingAvg(client.ratings) }}</td>
            <td :title="client.full_name">
              <star-rating
                v-model="client.process_result.value"
                :star-size="17"
                @rating-selected="updateRating(client)"
              ></star-rating>
            </td>
          </tr>
        </tbody>
      </table>
      <h5 v-else>Нет записей</h5>
    </div>
  </div>
</template>

<script>
import Attendance from "@/components/Progress/Journal/Attendance";
import Ratings from "@/components/Progress/Journal/Ratings.vue";

export default {
  components: {
    Attendance,
    Ratings,
  },
  created() {},
  data() {
    return {};
  },
  props: [
    "clients",
    "timetable",
    "group",
    "discipline",
    "part",
    "getJournal",
    "holidays",
  ],
  methods: {
    //установка планового урока
    setLessonplan(table, k) {
      this.$loading(true);
      this.$http
        .put(`business/timetables/${table.id}`, {
          lessonplan_id: table.lessonplan ? table.lessonplan.id : null,
        })
        .then((response) => {
          this.$set(this.timetable, k, response.data.data);
        })
        .catch((error) => {})
        .finally(() => {
          this.$loading(false);
        });
    },
    ratingAvg(ratings) {
      let count = ratings.length;
      let sum = 0;
      for (let i = 0; i < count; i++) {
        sum += ratings[i].value;
      }
      if (count > 0) return (sum / count).toFixed(1);
      return sum.toFixed(1);
    },
    updateRating(client) {
      this.$loading(true);
      this.$http
        .post(
          `business/progress/journal/groups/${this.group.id}/disciplines/${this.discipline.id}/parts/${this.part}`,
          { client_id: client.id, value: client.process_result.value }
        )
        .then((response) => {})
        .catch((error) => {})
        .finally(() => {
          this.$loading(false);
        });
    },
  },
};
</script>

<style lang="scss">
.journal-control {
  display: flex;

  & > li {
    margin-right: 10px;
  }
}
</style>

